import { requireTab } from "@/features/navigation/requireTab";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin")({
    beforeLoad: ({ context }) => requireTab(context, "admin"),
    component: () => <Outlet />,
});
